module.exports = __webpack_public_path__ + "img/btn5-2.66fa2409.png";